import {
  AgntAttsIcon,
  AgntConnectIcon,
} from "../../assets/landing/icons/burger-icons";

import { LeftNodes } from "../../assets/svgComponents/attsBlock/LeftNodes";

import { RightNodes } from "../../assets/svgComponents/attsBlock/RightNodes";

import {
  DiscordSvg,
  GitbookSvg,
  MediumSvg,
  TelegramSvg,
  TwitterSvg,
} from "../../assets/landing/icons/social";

import {
  BenzingaLogo,
  BinanceLogo,
  BlockonomiLogo,
  BTCLogo,
  BusinessInsidersLogo,
  CoinMCLogo,
  MarketWatchLogo,
  MorningStarLogo,
  StrInsidersLogo,
} from "../../assets/landing/icons/partners-icons";

import {
  ProjectIconSvg,
  UserIconSvg,
} from "../../assets/landing/icons/join-icons";

import AgntAmbassadorIcon from "assets/landing/icons/burger-icons/AgntAmbassadorIcon";
import AGNTDocsIcon from "assets/landing/icons/burger-icons/AGNTDocsIcon";
import AgntGymIcon from "assets/landing/icons/burger-icons/AgntGymIcon";
import AgntRegistrationIcon from "assets/landing/icons/burger-icons/AgntRegistrationIcon";
import AgntTeamIcon from "assets/landing/icons/burger-icons/AgntTeamIcon";
import DashboardIcon from "assets/svgComponents/dashboardTopBlock/DashboardIcon";
import ReferralsIcon from "assets/svgComponents/referralsPage/ReferralsIcon";
import {
  ChainSvg,
  ecoCardLeft,
  ecoCardRight,
  VisitSvg,
} from "../../assets/landing/icons/ecosystem-icon";

import Anton from "assets/landing/team/Anton.png";
import Michel from "assets/landing/team/Misha.png";
import Slava from "assets/landing/team/Slava.png";

import { Adoria } from "assets/landing/team/companies/Adoria";
import { Allianz } from "assets/landing/team/companies/Allianz";
import { BDLabs } from "assets/landing/team/companies/BDLabs";
import { Cowchain } from "assets/landing/team/companies/Cowchain";
import { Cult } from "assets/landing/team/companies/Cult";
import { Oni } from "assets/landing/team/companies/Oni";
import { Primex } from "assets/landing/team/companies/Primex";
import { Retrobridge } from "assets/landing/team/companies/Retrobriedg";
import { Wirex } from "assets/landing/team/companies/Wirex";

export const navigationLinks = [
  {
    id: 1,
    label: "Dashboard",
    link: "/dashboard",
    icon: DashboardIcon,
  },
  {
    id: 2,
    label: "Referrals",
    link: "/referrals",
    icon: ReferralsIcon,
  },
];

export const socialItems = [
  {
    id: 1,
    linkUrl: "https://blog.agnthub.ai/",
    icon: MediumSvg,
  },
  {
    id: 2,
    linkUrl: "https://x.com/agnt_hub",
    icon: TwitterSvg,
  },
  {
    id: 3,
    linkUrl: "https://t.me/agnt_ann",
    icon: TelegramSvg,
  },
  {
    id: 4,
    linkUrl: "https://discord.gg/agnthub",
    icon: DiscordSvg,
  },

  //COMING SOON
  {
    id: 5,
    linkUrl: "#",
    icon: GitbookSvg,
  },
];

export const partnersIcons = [
  {
    id: "Binance",
    icon: BinanceLogo,
    link: 'https://www.binance.com/en/square/post/30431552052393'
  },
  {
    id: "BTC",
    icon: BTCLogo,
    link: 'https://news.bitcoin.com/agnt-hub-launches-x-mini-apps-and-opens-the-next-chapter-for-native-web3-on-x' 
  },
  {
    id: "BusinessInsiders",
    icon: BusinessInsidersLogo,
     link: 'https://markets.businessinsider.com/news/stocks/agnt-hub-launches-x-mini-apps-and-opens-the-next-chapter-for-native-web3-on-x-1035244664' 
  },
  {
    id: "Benzinga",
    icon: BenzingaLogo,
    link: "https://www.benzinga.com/pressreleases/25/10/g47970991/agnt-hub-launches-x-mini-apps-and-opens-the-next-chapter-for-native-web3-on-x"
  },
  {
    id: "StreetInsiders",
    icon: StrInsidersLogo,
    link: "https://www.streetinsider.com/Globe+Newswire/AGNT+Hub+Launches+X+Mini+Apps+and+Opens+the+Next+Chapter+for+Native+Web3+on+X/25404728.html"
  },
  {
    id: "CoinMarketCap",
    icon: CoinMCLogo,
    link: "https://coinmarketcap.com/community/articles/68dd1dda6217ba7fe64b9779"
  },
  // {
  //   id: "MorningStar",
  //   icon: MorningStarLogo,
  //    link: ''
  // },
  {
    id: "MarketWatch",
    icon: MarketWatchLogo,
    link: "https://www.marketwatch.com/press-release/agnt-hub-launches-x-mini-apps-and-opens-the-next-chapter-for-native-web3-on-x-72cab286?mod=search_headline"
  },
  {
    id: "Blockonomi",
    icon: BlockonomiLogo,
    link: "https://blockonomi.com/agnt-hub-launches-x-mini-apps-and-opens-the-next-chapter-for-native-web3-on-x/"
  },
];

export const joinItems = [
  {
    title: "For Users",
    information: [
      "Get exclusive early access to onchain actions directly within X.",
      "Preregister now to become one of the first to earn, trade, and launch from your feed.",
      "Turn tweets into tradable Assets",
    ],
    linkName: "Preregister Now",
    icon: UserIconSvg,
    isBlueLine: true,
    url: "https://join.agnthub.ai",
  },
  {
    title: "For Projects",
    information: [
      "Launch your campaigns directly where your audience already engages.",
      "Deploy agents, run quests, and drive seamless onchain actions right inside the X feed.",
      "Launch embedded interfaces on your X pages",
    ],
    linkName: "Launch with AGNT",
    icon: ProjectIconSvg,
    url: "https://chromewebstore.google.com/detail/agntconnect/lgdfffagihonfnkcffpikpifhegcdkge?utm_source=item-share-cb",
  },
];

export const getNavigationFooterLinks = (t: (key: string) => string) => [
  {
    id: 1,
    title: t("footerNavigation.ecosystem.title"),
    items: [
      {
        name: t("footerNavigation.ecosystem.agntConnect"),
        url: "https://go.agnthub.ai/connect",
      },
      {
        name: t("footerNavigation.ecosystem.agntAtts"),
        url: "#",
      },
    ],
  },
  {
    id: 2,
    title: t("footerNavigation.community.title"),
    items: [
      {
        name: t("footerNavigation.community.registration"),
        url: "https://join.agnthub.ai",
      },
      {
        name: t("footerNavigation.community.gym"),
        url: "https://quests.agnthub.ai",
      },
      {
        name: t("footerNavigation.community.ambassadorProgram"),
        url: "#",
      },
    ],
  },

];

export const ecosystemItems = [
  {
    step: "Install AGNT Connect",
    stepIcon: LeftNodes,
    title: "AGNT Connect",
    desc: "A browser extension that embeds Web3 execution, analytics, SocialFi and InfoFi campaigns directly into the X interface.",
    itemCardImg: ecoCardLeft,
    descWidth: 20.541,
  },

  {
    step: "Visit AGNT Atts",
    stepIcon: RightNodes,
    title: "AGNT Atts",
    desc: "An AttentionFi protocol that turns tweets into tradable assets through pre-sale and bonding curve mechanics.",
    itemCardImg: ecoCardRight,
    descWidth: 22.285,
  },
];

export const attentionsItem = [
  {
    id: 11,
    title: "Protocol launch \n with AGNT.Hub",
    items: ["Embedded Interfaces", "SocialFi Launcher", "InfoFi Launcher"],
  },
  {
    id: 12,
    title: "Users engage \n via AGNT Connect",
    items: [
      "Advanced web3 analytics in X",
      "Onchain / Offchain actions ",
      "Crypto X Feed",
    ],
  },
  {
    id: 13,
    title: "Reward via AGNT.Hub \n Ecosystem",
    items:
      "Distribute rewards right inside AGNT Connect to Verified, high-quality contributors with tokens, or other perks.",
  },
  {
    id: 14,
    title: "Actions verified through \n the analytics layer",
    items:
      "AI analyzes the quality of the social content, while our infrastructure verifies the onchain actions.",
  },
];

export const attentionsItemMob = [
  {
    id: 15,
    title: "Protocol launch \n with AGNT.Hub",
    items: ["Embedded Interfaces", "SocialFi Launcher", "InfoFi Launcher"],
  },
  {
    id: 16,
    title: "Users engage \n via AGNT Connect",
    items: [
      "Advanced web3 analytics in X",
      "Onchain / Offchain actions ",
      "Crypto X Feed",
    ],
  },
  {
    id: 17,
    title: "Actions verified through the analytics layer",
    items:
      "AI analyzes the quality of the social content, while our infrastructure verifies the onchain actions.",
  },
  {
    id: 18,
    title: "Reward via AGNT.Hub \n Ecosystem",
    items:
      "Distribute rewards right inside AGNT Connect to Verified, high-quality contributors with tokens, or other perks.",
  },
];

export const ecosystemDropDownIcons = [
  {
    id: 1,
    name: "AGNT Atts",
    url: "#",
    icon: AgntAttsIcon,
  },

  {
    id: 4,
    name: "AGNT Connect",
    url: "https://go.agnthub.ai/connect",
    icon: AgntConnectIcon,
  },
];

export const communityItems = [
  {
    icon: AgntRegistrationIcon,
    name: "Registration",
    url: "https://join.agnthub.ai",
  },
  {
    icon: AgntGymIcon,
    name: "AGNT Gym",
    url: "https://quests.agnthub.ai",
  },
  {
    icon: AgntAmbassadorIcon,
    name: "Ambassador program",
    url: "#",
  },
];

export const aboutItems = [
  {
    icon: AgntTeamIcon,
    name: "Team",
    url: "#",
  },
  {
    icon: AGNTDocsIcon,
    name: "Docs",
    url: "https://docs.agnthub.ai",
  },
];

export enum EStage {
  development = "development",
  staging = "staging",
  production = "production",
}

export type TStageValue = {
  [key in EStage]: string;
};

const ENVIROMENT_STAGE: EStage =
  (process.env.REACT_APP_STAGE as EStage) || EStage.development;

const preregisterLink: TStageValue = {
  [EStage.development]:
    "https://dev.d24h3pmbn6w073.amplifyapp.com/chats-demo/faq/",
  [EStage.staging]: "https://dev.d24h3pmbn6w073.amplifyapp.com/chats-demo/faq/",
  [EStage.production]:
    "https://dev.d24h3pmbn6w073.amplifyapp.com/chats-demo/faq/",
};

export const PREREGISTER_LINK = preregisterLink[ENVIROMENT_STAGE];

const joinWhitelistLink: TStageValue = {
  [EStage.development]: "https://join.agnthub.ai",
  [EStage.staging]: "https://join.agnthub.ai",
  [EStage.production]: "https://join.agnthub.ai",
};

export const JOIN_WHITELIST_LINK = joinWhitelistLink[ENVIROMENT_STAGE];
export const DOWNLOAD_LINK =
  "https://chromewebstore.google.com/detail/agntconnect/lgdfffagihonfnkcffpikpifhegcdkge?utm_source=item-share-cb";

export const TeamData = [
  {
    name: "Michael Adzhoiev",
    role: "CEO",
    image: Michel,
    companies: [Allianz, Retrobridge, Wirex, Cowchain],
  },
  {
    name: "Slava Ivchenko",
    role: "CPO",
    image: Slava,
    companies: [Cowchain],
  },
  {
    name: "Anton Demenko",
    role: "CMO",
    image: Anton,
    companies: [Primex, Cult, Oni, Adoria, BDLabs],
  },
];

export const refcodes = ['UNREAL']